import { render, staticRenderFns } from "./ProjectInteractionsFiltered.vue?vue&type=template&id=0f38fdaf&"
import script from "./ProjectInteractionsFiltered.vue?vue&type=script&lang=js&"
export * from "./ProjectInteractionsFiltered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports